module.exports = __webpack_public_path__ + "img/9.c19e01a9.png";